const toggleImage = (node) => {
  const mediaAssetsImages = node.querySelectorAll(
    '[data-media-assets-block-img]'
  );
  const colorPickers = node.querySelectorAll('[data-color-swatch-picker]');

  colorPickers.forEach((colorPicker, index) => {
    colorPicker.addEventListener('click', () => {
      const activeColorPicker = node.querySelector(
        '[data-color-swatch-picker][data-active="true"]'
      );
      const activeColorPickerIndex =
        Array.from(colorPickers).indexOf(activeColorPicker);

      activeColorPicker.setAttribute('data-active', 'false');
      mediaAssetsImages[activeColorPickerIndex].setAttribute(
        'data-active',
        'false'
      );
      colorPicker.setAttribute('data-active', 'true');
      mediaAssetsImages[index].setAttribute('data-active', 'true');
    });
  });
};

export const initMediaSwatches = () => {
  const mediaAssetsBlocks = document.querySelectorAll(
    '[data-asset-media-block]'
  );

  mediaAssetsBlocks.forEach((mediaAssetsBlock) => {
    toggleImage(mediaAssetsBlock);
  });
};
